import history from '../history';
import queryString from 'query-string';
import { flattenObj } from './utils';

export function getQueryParams() {
    return queryString.parse(history.location.search);
}

export function setQueryParams(params) {
    if (params) {
        const searchParams = { ...params };
        Object.keys(searchParams).forEach(prop => {
            if (!searchParams[prop])
                searchParams[prop] = [];
            else if (typeof searchParams[prop] === 'object')
                searchParams[prop] = flattenObj(searchParams[prop]);
        });

        const search = queryString.stringify({ ...getQueryParams(), ...searchParams });
        history.replace({ search });
    } else {
        history.replace({ search: '' });
    }
}



// WEBPACK FOOTER //
// ./src/lib/urlUtils.js